export const CUSTOM_EXPIRATION_VALUE = -999;

export const EXPIRATION_OPTIONS = [
    { label: 'NSBonus.limit', value: 0 },
    { label: 'NSBonus.weeks', value: 1.21e+9 },
    { label: 'month', value: 2.628e+9 },
    { label: 'NSBonus.two', value: 5.256e+9 },
    { label: 'NSBonus.three', value: 7.884e+9 },
    { label: 'NSBonus.halfYear', value: 1.577e+10 },
    { label: 'year', value: 3.154e+10 },
    { label: 'NSBonus.oneAndHalfYear', value: 4.73e+10 },
    { label: 'NSBonus.twoYears', value: 6.307e+10 },
    { label: 'NSBonusMode.customDuration', value: CUSTOM_EXPIRATION_VALUE },
];

export const DURATION_UNITS = [
    { label: 'NSBonusMode.unitMinutes', value: 60000 },
    { label: 'NSBonusMode.unitHours', value: 3600000 },
    { label: 'NSBonusMode.unitDays', value: 86400000 },
    { label: 'NSBonusMode.unitWeeks', value: 604800000 },
    { label: 'NSBonusMode.unitMonths', value: 2628000000 },
];
